import React from 'react';

const ImageGrid = ({ children }) => (
  <div className="image-grid">{children}</div>
);

export default ImageGrid;
